import Documents from './Documents';
import Data from './Data';
import { Layout } from '../common';
import { Button, Header } from '../../components';
import { createTcrrExampleProtocol } from '../../demo';

import { connect } from 'react-redux';
import React, { Fragment } from 'react';

/*
const SvgTest = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 1 1"
  >
    <rect x="0" y="0" width="1" height="1" />
  </svg>
);
*/

const Home = ({ app, route, dispatch, actions }) => {
  const onTcrrExampleProtocol = () => {
    createTcrrExampleProtocol(dispatch);
  };

  return (
    <Layout app={app} route={route}>
      <Header as="h1">Nosturi</Header>
      <p>
        <strong>App version:</strong> {process.env.REACT_APP_VERSION}
      </p>
      <Documents />
      <Data />
      {process.env.NODE_ENV !== 'production' && (
        <Fragment>
          <Header as="h2">**Demo**</Header>
          <p>
            <Button
              content="TCRR Example Protocol"
              onClick={onTcrrExampleProtocol}
            />
          </p>
        </Fragment>
      )}
    </Layout>
  );
};

Home.slug = '';
Home.title = 'Home';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js